module.exports = __webpack_public_path__ + "static/img/brmm1.6c05d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/brmm1.png
// module id = XqG9
// module chunks = 0